import React from 'react';
import PropTypes from 'prop-types';

const OperatingLayersSection = ({ items }) => {
  const layers = Array.isArray(items) ? items : [];

  return (
    <section id="experience" className="px-6 py-20 md:py-28">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#f8f5ed] mb-3">
            Built for real workflows
          </h2>
          <p className="text-[#d8d2c5] max-w-2xl">
            Layers that keep your group aligned—engagement, books, automation, and decision-making.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {layers.map((layer, idx) => (
            <div
              // eslint-disable-next-line react/no-array-index-key
              key={`layer-${idx}`}
              className="rounded-2xl border border-white/10 bg-white/5 p-6"
            >
              <div className="inline-flex items-center rounded-full bg-emerald-500/10 px-3 py-1 text-xs font-medium text-emerald-200 ring-1 ring-emerald-400/20 mb-4">
                {layer.badge}
              </div>
              <div className="text-xl font-semibold text-[#f8f5ed] mb-2">{layer.title}</div>
              <div className="text-sm text-[#d8d2c5]/85 leading-relaxed">{layer.copy}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

OperatingLayersSection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      badge: PropTypes.string,
      title: PropTypes.string,
      copy: PropTypes.string,
    })
  ),
};

OperatingLayersSection.defaultProps = {
  items: [],
};

export default OperatingLayersSection;
